import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesServicesReturnFormMain } from './modules/ui/Main';

const ServicesReturnFormPage = (
  <SuspensePage>
    <PagesServicesReturnFormMain />
  </SuspensePage>
);

export default ServicesReturnFormPage;
